<template>
  <tr v-if="watch && board">
    <td class="text-xs-left">
      <v-avatar size="32">
        <v-icon color="primary">view_carousel</v-icon>
      </v-avatar>
    </td>

    <td class="text-xs-left link">
      <router-link :to="boardRoute">{{board.attributes.name}}</router-link>
    </td>

    <td class="hidden-sm-and-down text-xs-left board-statuses">
      <span v-for="(status, idx) in statuses.filter(st => ticketCountForStatus(st) > 0)" :key="idx">
        <v-chip outline disabled small :style="{'border-color': status.attributes.color }">
          <v-avatar>{{ticketCountForStatus(status)}}</v-avatar>
          <span  class="text-truncate">{{status.attributes.name}}</span>
        </v-chip>
      </span>
    </td>

    <td class="hidden-sm-and-down text-xs-left">
      {{assignedTicketCount}} assigned to you
    </td>

    <td class="text-xs-left">
      <v-icon small>access_time</v-icon>
        {{lastActive| formatDateAgo}}
      </v-flex>
    </td>

    <td class="text-xs-right">
      <v-tooltip
        bottom
        color="#fff"
        >
        <v-btn
          icon
          @click="unsetWatch()"
          slot="activator"
          >
          <v-icon>visibility_off</v-icon>
        </v-btn>
        <span class="black--text">Ignore</span>
      </v-tooltip>
    </td>
  </tr>
</template>

<script>
  import { EventBus } from '@/utilities/event-bus'

  import watchService from '@/services/watch'
  import statusService from '@/services/status'
  import ticketService from '@/services/ticket'

  export default {
    name: 'watch-board-row',

    components: {
    },

    props: ['watch', 'board'],

    data () {
      return {
        statuses: [],
        tickets: []
      }
    },

    mounted () {
      this.loadBoardStatuses()
      this.loadBoardTickets()
    },

    computed: {
      boardRoute () {
        if (this.board) {
          return { path: this.board.links.show_uri }
        }
        return ''
      },

      lastActive () {
        return this.watch.attributes.changed_at
      },

      assignedTicketCount () {
        let count = parseInt(this.board.attributes.assigned_ticket_count || 0)
        if (count === 1) {
          return count + ' ticket is'
        } else if (count > 1) {
          return count + ' tickets are'
        } else {
          return 'No tickets are'
        }
      }
    },

    methods: {
      loadBoardStatuses () {
        statusService.boardIndex(
          (data) => {
            this.statuses = data
          },
          (err) => {
            console.log(err)
          },
          this.board.id
        )
      },

      loadBoardTickets () {
        ticketService.boardIndex(
          (data) => {
            this.tickets = data
          },
          (err) => {
            console.log(err)
          },
          this.board.id
        )
      },

      ticketCountForStatus (status) {
        return this.tickets.filter(tck => parseInt(tck.relationships.status.data.id) == parseInt(status.id)).length
      },

      memberThumbUrl (membership) {
        if (membership && membership.links && membership.links.avatar_uri) {
          return (process.env.API_URL + membership.links.avatar_uri)
        }
      },

      unsetWatch () {
        watchService.boardDelete(
          (data) => {
            EventBus.$emit('watch-deleted', this.watch)
          },
          (err) => {
            console.log(err)
          },
          this.board.id,
          this.watch.id
        )
      }
    }
  }
</script>

<style lang="scss" scoped>
  .v-chip .v-icon {
    color: inherit;
    border: 1px solid grey;
  }
  .v-chip .v-avatar {
    color: inherit;
    border: 1px solid grey;
  }
  .v-avatar .v-icon {
    color: inherit;
    border: 1px solid grey;
  }
  td.board-statuses {
    width: 35%;
  }
</style>



// WEBPACK FOOTER //
// src/components/watch/_board_row.vue